const pathsBase = {
  LOGIN: '/login',
  HOME: '/',
  USER_NOT_FOUND: '/user-not-found',
};

type PathKeys = keyof typeof pathsBase;

type Paths = {
  [K in PathKeys]: string;
};

const paths: Paths = {
  LOGIN: pathsBase.LOGIN,
  HOME: pathsBase.HOME,
  USER_NOT_FOUND: pathsBase.USER_NOT_FOUND,
};

export { pathsBase, paths };
